webpackJsonp([97],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/hotel.json": [
		115,
		10
	],
	"./ja/hotel.json": [
		116,
		9
	],
	"./ko/hotel.json": [
		117,
		8
	],
	"./zh-CN/hotel.json": [
		118,
		7
	],
	"./zh-TW/hotel.json": [
		119,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 10;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(16);
__webpack_require__(6);
__webpack_require__(5);

__webpack_require__(101);

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Vue) {

var init = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var text, moment, login, OwlCarousel;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 8));

                    case 2:
                        _context.next = 4;
                        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 12));

                    case 4:
                        _context.next = 6;
                        return __webpack_require__(10)("./" + locale + '/hotel.json');

                    case 6:
                        text = _context.sent;
                        _context.next = 9;
                        return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 22));

                    case 9:
                        moment = _context.sent;
                        _context.next = 12;
                        return __webpack_require__.e/* import() */(80/* duplicate */).then(__webpack_require__.bind(null, 134));

                    case 12:
                        login = _context.sent;
                        _context.next = 15;
                        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 11));

                    case 15:
                        OwlCarousel = _context.sent;

                        $(document).ready(function () {
                            OwlCarousel.initOwlCarousel();
                        });

                        $(function () {
                            $('#change-room').change(function (event) {
                                //房型庫存頁面切換房型
                                window.location = urlPrefix + '/room/' + $("#change-room").val();
                            });

                            function fetchInventory(cb) {
                                var that = this;
                                that.isLoading = true;
                                that.checkInDate = '';
                                $.ajax(urlPrefix + '/room/inventory/' + roomNo, {
                                    type: 'POST',
                                    headers: {
                                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                    },
                                    data: {
                                        'year': that.calendar.year,
                                        'month': that.calendar.month,
                                        'room-qty': that.roomQty,
                                        'nights': that.nights
                                    },
                                    dataType: 'json',
                                    success: function success(res) {
                                        if (true === res.status) {
                                            if (true === res.waiting) {
                                                that.waiting_on = res.waiting;
                                            }
                                            var row = that.calendarRow;
                                            var inventory = [];
                                            var inventoryWeek = void 0;
                                            for (var i = 0; i <= row; i++) {
                                                inventoryWeek = [];
                                                for (var j = 7 * i; j < 7 * (i + 1); j++) {
                                                    if (j < that.calendar.firstDateDay) {
                                                        inventoryWeek.push({
                                                            current: false
                                                        });
                                                    } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                                        inventoryWeek.push({
                                                            current: false
                                                        });
                                                    } else {
                                                        inventoryWeek.push({
                                                            date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                                            price: res.inventory[j - that.calendar.firstDateDay].price,
                                                            qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                                            available: res.inventory[j - that.calendar.firstDateDay].available,
                                                            applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                                            isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                                            current: true
                                                        });
                                                    }
                                                }
                                                inventory.push(inventoryWeek);
                                            }
                                            that.inventory = inventory;
                                        } else {
                                            alert(res.message);
                                            cb();
                                        }
                                        that.isLoading = false;
                                    }
                                });
                            }

                            if (document.getElementById('vue-room') !== null) {
                                var firstDay = moment(firstSaleDay);
                                var calendarInitDate = firstDay; //第一天有放房之後的日期才可以訂房

                                var vm = new Vue({
                                    el: '#vue-room',
                                    data: {
                                        nights: 1,
                                        roomQty: 1,
                                        calendar: {
                                            firstDay: firstDay,
                                            year: calendarInitDate.year(),
                                            month: calendarInitDate.month() + 1,
                                            firstDateDay: calendarInitDate.startOf('month').day(),
                                            endDate: calendarInitDate.endOf('month').date()
                                        },
                                        waiting_on: false,
                                        inventory: [],
                                        checkInDate: '',
                                        isWaiting: 0,
                                        isLoading: false,
                                        nextLoading: false
                                    },
                                    created: function created() {
                                        // 先抓取第一個月份的庫存
                                        fetchInventory.call(this);
                                    },
                                    computed: {
                                        calendarRow: function calendarRow() {
                                            return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                                        },
                                        currentMonth: function currentMonth() {
                                            return this.calendar.firstDay.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                                        },
                                        checkInDateSend: function checkInDateSend() {
                                            if (this.checkInDate instanceof moment) {
                                                return this.checkInDate.format('YYYY-MM-DD');
                                            }
                                            return '';
                                        }
                                    },
                                    methods: {
                                        prev: function prev() {
                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).subtract(1, 'months');
                                            if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                                                this.calendar.year = changeDate.year();
                                                this.calendar.month = changeDate.month() + 1;
                                                this.calendar.firstDateDay = changeDate.startOf('month').day();
                                                this.calendar.endDate = changeDate.endOf('month').date();
                                                fetchInventory.call(this, this.next);
                                            } else {
                                                alert(text.SystemText.NotFurther);
                                            }
                                        },
                                        next: function next() {
                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).add(1, 'months');
                                            this.calendar.year = changeDate.year();
                                            this.calendar.month = changeDate.month() + 1;
                                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                                            this.calendar.endDate = changeDate.endOf('month').date();
                                            fetchInventory.call(this, this.prev);
                                        },
                                        selectRoomQty: function selectRoomQty() {
                                            this.checkInDate = '';
                                            fetchInventory.call(this, function () {});
                                        },
                                        selectNights: function selectNights() {
                                            this.checkInDate = '';
                                            fetchInventory.call(this, function () {});
                                        },
                                        selectCheckInDate: function selectCheckInDate(date, isWaiting, event) {
                                            var this$ = $(event.target).closest('a');
                                            this$.focus();
                                            this.checkInDate = date;
                                            this.isWaiting = isWaiting || 0;
                                        },
                                        backList: function backList() {
                                            window.location = urlPrefix + '/room/list';
                                        },
                                        submitNext: function submitNext(event) {
                                            var that = this;
                                            if (that.checkInDate instanceof moment) {
                                                that.nextLoading = true;
                                                var form$ = $('#room-submit-form');
                                                login.check(function (err, status, userInfo) {
                                                    if (status === true) {
                                                        form$.submit();
                                                    } else {
                                                        if (enableMember === true) {
                                                            that.nextLoading = false;
                                                            login.initModal($(event.target), function (target) {
                                                                that.nextLoading = true;
                                                                form$.submit();
                                                            }, !!that.isWaiting);
                                                        } else {
                                                            form$.submit();
                                                        }
                                                    }
                                                });
                                            } else {
                                                alert(text.SystemText.SelectDate);
                                            }
                                        }
                                    }
                                });
                            }
                        });

                        $('.readmore').click(function (event) {
                            var that$ = $(this);
                            that$.closest('div.text-content').find('div.texthide').removeClass('texthide').addClass('showmore').end().find('div.overtext').remove();
                            that$.remove();
                        });

                        // 2022-05-31 野漾莊園一般訂房增加公告
                        $(document).ready(function () {
                            $('#autoNotice').get(0).click();
                        });

                        $('#Notice-remember').on('change', function () {
                            $.ajax(urlPrefix + '/api/index/notice', {
                                type: 'post',
                                headers: {
                                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
                                }
                            });
                        });

                    case 21:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function init() {
        return _ref.apply(this, arguments);
    };
}();

__webpack_require__(243);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

init();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(108)))

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[274]);


// WEBPACK FOOTER //
// js/build/room-55fb15e5827d0458f059.js